module.exports = __webpack_public_path__ + "img/thumbnail_Koala_m_normal.241b9ba7.png";